<template>
  <main class="CareerPage">
    <Heading />
    <Teams />
    <WhatToExpect />
    <OurValues />
    <ApplicationProcess />
    <Openings />
  </main>
</template>

<script>
import Heading from '../components/CareersPage/Heading.vue';
import WhatToExpect from '../components/CareersPage/WhatToExpect.vue';
import Teams from '../components/CareersPage/Teams.vue';
import OurValues from '../components/CareersPage/OurValues.vue';
import ApplicationProcess from '../components/CareersPage/ApplicationProcess.vue';
import Openings from '../components/CareersPage/Openings.vue';

export default {
  components: {
    Heading,
    Teams,
    WhatToExpect,
    OurValues,
    Openings,
    ApplicationProcess,
  },
};
</script>

<style scoped>
.CareerPage {
  --page-text-color: #2b4047;
  padding-top: 76px;
  min-height: 100vh;
}
</style>
